import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavigationItem } from '@app/core/types/navigation.interface';
import { MenuGroupVerticalComponent } from './menu-group/menu-group.component';
import { MenuItemVerticalComponent } from './menu-item/menu-item.component';
import { AuthenticationService } from '@app/core/auth';
import { MenuCollapseComponent } from './menu-collapse/menu-collapse.component';
import { MenuStateService } from '@app/core/services/menu-state.service';
import { NgScrollbarModule } from 'ngx-scrollbar';

@Component({
  selector: 'app-vertical-menu',
  standalone: true,
  imports: [MenuGroupVerticalComponent, MenuItemVerticalComponent, MenuCollapseComponent, RouterModule, NgScrollbarModule],
  template: `
  <ng-scrollbar style="height: calc(100vh - 130px)" visibility="hover" orientation="vertical">
    <div class="navbar-content">
      <ul class="nav coded-inner-navbar">
        @for (item of menus(); track item) {
          @if (item.type === 'group') {
            <app-menu-group-vertical [item]="item" />
          } @else if (item.type === 'item') {
            <app-menu-item [item]="item" [level]="0" [parentId]="''" />
          } @else if (item.type === 'collapsible') {
            <app-menu-collapse [item]="item" [level]="0" [parentId]="''" />
          }
        }
      </ul>
    </div>
  </ng-scrollbar>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerticalMenuComponent implements OnInit {
  private readonly menuStateService = inject(MenuStateService);
  readonly authService = inject(AuthenticationService);
  readonly menus = input.required<NavigationItem[]>();

  ngOnInit(): void {
    this.menuStateService.initialize(this.menus());
  }
}
